import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { alertActions, userActions } from '_store';
import { history, fetchWrapper } from '_helpers';

// create slice

const name = 'auth';
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const slice = createSlice({ name, initialState, reducers });

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        value: JSON.parse(localStorage.getItem('auth'))
    }
}

function createReducers() {
    return {
        setAuth,
        setToken
    };

    function setAuth(state, action) {
        state.value = action.payload;
    }

    function setToken(state, action) {
        state.value.token = action.payload;
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;

    return {
        login: login(),
        logout: logout()
    };

    function login() {
        return createAsyncThunk(
            `${name}/login`,
            async function ({ username, password }, { dispatch }) {
                dispatch(alertActions.clear());
                const data = { 'username': username, 'password': password }
                try {
                    const user = await fetchWrapper.post(`${baseUrl}/token`, data);

                    // set auth user in redux state
                    dispatch(authActions.setAuth(user));
                    dispatch(userActions.setUser(user))

                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('auth', JSON.stringify(user));

                    // get return url depending on the user's role                    
                    let url = '/';
                    switch(user.role){
                        case ("user_geolocalisation"):
                            url ="/geolocalisation";
                            break;
                        case ("admin"):
                            url="/donnees";
                            break;
                        //case ("user_portal"):                            
                        default:
                            url="/";
                            break;
                    }
                    const { from } = { from: { pathname: url } };
                    history.navigate(from);
                } catch (error) {
                    dispatch(alertActions.error(error));
                }
            }
        );
    }

    function logout() {
        return createAsyncThunk(
            `${name}/logout`,
            function (arg, { dispatch }) {
                dispatch(authActions.setAuth(null));
                localStorage.removeItem('auth');
                history.navigate('/account/login');
            }
        );
    }
}